export const getOnlineOfferEngagementEndpoint = (offerId: string) =>
  `${process.env.API_URL}/dms/v1/business-case/online-offer/${offerId}/engagement`;
